import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CardHeader from "../../components/Card/CardHeader";

// Styled versions of Tabs and Tab using the legacy style logic
const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: "unset",
  overflowX: "visible",
  "& .MuiTab-root": {
    fontSize: "0.875rem",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  minHeight: "unset",
  minWidth: "unset",
  width: "unset",
  height: "unset",
  maxWidth: "unset",
  maxHeight: "unset",
  padding: "10px 15px",
  borderRadius: "3px",
  lineHeight: "24px",
  marginLeft: "4px",
  fontWeight: 500,
  fontSize: "12px",
  color: "#fff",
  "&:last-child": {
    marginLeft: 0,
  },
  "&.Mui-selected": {
    backgroundColor: "rgba(255,255,255,0.2)",
    transition: "0.2s background-color 0.1s",
  },
  "& > svg, & > .material-icons": {
    verticalAlign: "middle",
    margin: "-1px 5px 0 0",
  },
}));

const TitleBox = styled(Box)(({ theme, rtl }) => ({
  float: rtl ? "right" : "left",
  padding: rtl ? "10px 0 10px 10px" : "10px 10px 10px 0",
  lineHeight: "24px",
}));

export default function CustomTabs({ headerColor, plainTabs, tabs, title, rtlActive = false }) {
  const [value, setValue] = useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Card plain={plainTabs} sx={{ border: "1px solid #e0ef66", backgroundColor: "#e0e2ff" }}>
      <CardHeader color={headerColor} plain={plainTabs}>
        {title && <TitleBox rtl={rtlActive}>{title}</TitleBox>}
        <StyledTabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
          {tabs.map((prop, key) => {
            const iconProps = prop.tabIcon ? { icon: <prop.tabIcon /> } : {};
            return <StyledTab key={key} label={prop.tabName} {...iconProps} />;
          })}
        </StyledTabs>
      </CardHeader>
      <CardBody>
        {tabs.map((prop, key) => {
          return key === value ? <Box key={key}>{prop.tabContent}</Box> : null;
        })}
      </CardBody>
    </Card>
  );
}

CustomTabs.propTypes = {
  headerColor: PropTypes.oneOf(["warning", "success", "danger", "info", "primary", "rose"]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string.isRequired,
      tabIcon: PropTypes.elementType,
      tabContent: PropTypes.node.isRequired,
    })
  ).isRequired,
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool,
};
